import React from "react";

const InputField = ({ value, onChange, placeholder, disabled, options, type = "text", title, full = true, onKeyPress }) => {
  return (
    <div className={`relative flex flex-col my-4 ${full ? "w-full" : "w-96 max-w-[80%]"}`}>
      {title && <label className='px-2 mb-1 text-sm text-black-700 dark:text-black-400'>{title}</label>}
      {type !== "select" && (
        <input
          className={`h-12 rounded-lg px-2 bg-black-050 dark:bg-black-900 text-black dark:text-white leading-[1px] ${
            type === "password" ? "tracking-widest placeholder:tracking-normal" : "tracking-wide"
          }`}
          value={value}
          onKeyPress={onKeyPress}
          onChange={onChange}
          disabled={disabled}
          placeholder={placeholder}
          type={type}
        />
      )}
      {type === "select" && (
        <select className='h-12 rounded-lg py-1 px-2 bg-black-050 dark:bg-black-900 text-black dark:text-white leading-[1px]' value={value} onChange={onChange}>
          {options.map(({ value, description }) => (
            <option key={value} value={value}>
              {description}
            </option>
          ))}
        </select>
      )}
    </div>
  );
};

export default InputField;
